<div class="editorMenuGripLayout">
  <div class="NodeNetzgrafikVariante" *ngIf="!disableBackend">
    <div class="LabelNetzgrafik">
      <div class="LabelNetzgrafikVariante" title="{{ label$ | async }}">
        {{ label$ | async }}
      </div>
      <div class="LabelNetzgrafikVarianteSaveStatus">
        <ng-container *ngIf="isWritable$ | async; else readonly">
          <ng-container *ngIf="modified$ | async; else saved">
            <span>{{ "app.view.editor-menu.save-changes" | translate }}</span>
            <sbb-icon svgIcon="arrows-circle-small" class="spinning"></sbb-icon>
          </ng-container>
          <ng-template #saved>
            <span>{{ "app.view.editor-menu.changes-saved" | translate }}</span>
            <sbb-icon svgIcon="circle-tick-small"></sbb-icon>
          </ng-template>
        </ng-container>
        <ng-template #readonly>
          <span>{{ "app.view.editor-menu.read-mode" | translate }}</span>
          <sbb-icon svgIcon="binoculars-small"></sbb-icon>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="NodeFilter">
    <ng-container
      *ngIf="
        !filterService.isAnyFilterActive() &&
        !filterService.isTemporaryDisableFilteringOfItemsInViewEnabled()
      "
    >
      <button
        mode="icon"
        class="ButtonFilter"
        (click)="onFilter()"
        [title]="'app.view.editor-menu.show-hide-filter' | translate"
      >
        <sbb-icon svgIcon="filter-medium" height="25px" width="25px" aria-hidden="false"></sbb-icon>
      </button>
    </ng-container>
    <ng-container
      *ngIf="
        !filterService.isAnyFilterActive() &&
        filterService.isTemporaryDisableFilteringOfItemsInViewEnabled()
      "
    >
      <button
        mode="icon"
        class="ButtonFilter"
        (click)="onFilter()"
        [title]="'app.view.editor-menu.show-hide-filter' | translate"
      >
        <sbb-icon
          svgIcon="filter-x-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>

    <ng-container
      *ngIf="
        filterService.isAnyFilterActive() &&
        !filterService.isTemporaryDisableFilteringOfItemsInViewEnabled()
      "
    >
      <button
        mode="icon"
        class="ButtonFilter ButtonFilterActive"
        (click)="onFilter()"
        [title]="'app.view.editor-menu.show-hide-filter' | translate"
      >
        <sbb-icon svgIcon="filter-medium" height="25px" width="25px" aria-hidden="false"></sbb-icon>
      </button>
    </ng-container>
    <ng-container
      *ngIf="
        filterService.isAnyFilterActive() &&
        filterService.isTemporaryDisableFilteringOfItemsInViewEnabled()
      "
    >
      <button
        mode="icon"
        class="ButtonFilter ButtonFilterActive"
        (click)="onFilter()"
        [title]="'app.view.editor-menu.show-hide-filter' | translate"
      >
        <sbb-icon
          svgIcon="filter-x-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
  </div>

  <div class="NodeZoomOut">
    <button
      mode="ghost"
      class="ButtonZoomOut"
      (click)="onZoomOut()"
      [title]="'app.view.editor-menu.zoom-out' | translate"
    >
      -
    </button>
  </div>
  <div class="NodeZoomValue">
    <div class="ZoomValue" (click)="onZoom100()">{{ getZoomFactor() }}%</div>
  </div>
  <div class="NodeZoomIn">
    <button
      mode="ghost"
      class="ButtonZoomIn"
      (click)="onZoomIn()"
      [title]="'app.view.editor-menu.zoom-in' | translate"
    >
      +
    </button>
  </div>

  <div class="NodeTopologieEditor" [class.isStreckengrafikEditing]="isStreckengrafikEditing()">
    <ng-container *ngIf="!isTopologyEditing()">
      <button
        mode="icon"
        class="ButtonTopologieEditor NetzgrafikEditing"
        [class.isStreckengrafikEditing]="isStreckengrafikEditing() || isAnalytics()"
        [class.readonly]="isStreckengrafikEditing() || isAnalytics() || !getVariantIsWritable()"
        [disabled]="isStreckengrafikEditing() || isAnalytics() || !getVariantIsWritable()"
        (click)="onTopologieEditor()"
        [title]="'app.view.editor-menu.topology-editor-disabled' | translate"
        data-testid="topology-editor-button"
      >
        <sbb-icon
          svgIcon="network-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
    <ng-container *ngIf="isTopologyEditing()">
      <button
        mode="icon"
        class="ButtonTopologieEditor TopologyEditing"
        [class.isStreckengrafikEditing]="isStreckengrafikEditing() || isAnalytics()"
        [disabled]="isStreckengrafikEditing() || isAnalytics()"
        (click)="onTopologieEditor()"
        [title]="'app.view.editor-menu.topology-editor-enabled' | translate"
      >
        <sbb-icon
          svgIcon="network-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
  </div>

  <div class="MultiNodeMoving" [class.isStreckengrafikEditing]="isStreckengrafikEditing()">
    <ng-container *ngIf="!isMultiNodeMoving()">
      <button
        mode="icon"
        class="ButtonMultiNodeMoving NetzgrafikEditing"
        [class.isStreckengrafikEditing]="isStreckengrafikEditing() || isAnalytics()"
        [disabled]="isStreckengrafikEditing() || isAnalytics()"
        (click)="onMultiNodeMoving()"
        [title]="'app.view.editor-menu.multiple-selection-tool-disabled' | translate"
      >
        <svg
          viewBox="0 0 1024 1024"
          style="vertical-align: middle; pointer-events: none"
          height="31"
          width="31"
        >
          <path
            class="ButtonMultiNodeMoving"
            [class.disabled]="isStreckengrafikEditing() || isAnalytics()"
            d="M598.186667 955.733333h-0.443734a17.117867 17.117867 0 0 1-15.240533-10.325333L476.859733 699.733333H426.666667a17.066667 17.066667 0 1 1 0-34.133333h35.5328l-136.533334-317.525333a17.066667 17.066667 0 0 1 22.408534-22.408534l317.525333 136.533334V426.666667a17.066667 17.066667 0 1 1 34.133333 0v50.158933l245.640534 104.8064a17.083733 17.083733 0 0 1 0.9216 30.976l-149.486934 74.752 153.924267 153.924267a17.0496 17.0496 0 0 1 0 24.132266l-85.333333 85.333334a17.0496 17.0496 0 0 1-24.132267 0l-153.856-153.856-73.9328 149.3504a17.066667 17.066667 0 0 1-15.291733 9.489066zM682.666667 750.933333a17.066667 17.066667 0 0 1 12.066133 5.000534L853.333333 914.5344 914.5344 853.333333l-158.600533-158.600533a17.015467 17.015467 0 0 1 4.437333-27.323733l137.6768-68.829867-222.037333-94.737067-0.1024-0.034133-301.9776-129.877333 129.860266 301.994666 0.034134 0.068267 95.453866 222.020267 68.096-137.5744A17.066667 17.066667 0 0 1 682.666667 750.933333z m-341.333334-51.2h-85.333333a17.066667 17.066667 0 1 1 0-34.133333h85.333333a17.066667 17.066667 0 1 1 0 34.133333z m-170.666666 0H85.333333a17.066667 17.066667 0 0 1-17.066666-17.066666v-85.333334a17.066667 17.066667 0 1 1 34.133333 0v68.266667h68.266667a17.066667 17.066667 0 1 1 0 34.133333zM85.333333 529.066667a17.066667 17.066667 0 0 1-17.066666-17.066667v-85.333333a17.066667 17.066667 0 0 1 34.133333 0v85.333333a17.066667 17.066667 0 0 1-17.066667 17.066667z m597.333334-170.666667a17.066667 17.066667 0 0 1-17.066667-17.066667v-85.333333a17.066667 17.066667 0 1 1 34.133333 0v85.333333a17.066667 17.066667 0 0 1-17.066666 17.066667zM85.333333 358.4a17.066667 17.066667 0 0 1-17.066666-17.066667v-85.333333a17.066667 17.066667 0 0 1 34.133333 0v85.333333a17.066667 17.066667 0 0 1-17.066667 17.066667z m597.333334-170.666667a17.066667 17.066667 0 0 1-17.066667-17.066666V102.4h-68.266667a17.066667 17.066667 0 1 1 0-34.133333h85.333334a17.066667 17.066667 0 0 1 17.066666 17.066666v85.333334a17.066667 17.066667 0 0 1-17.066666 17.066666zM85.333333 187.733333a17.066667 17.066667 0 0 1-17.066666-17.066666V85.333333a17.066667 17.066667 0 0 1 17.066666-17.066666h85.333334a17.066667 17.066667 0 0 1 0 34.133333H102.4v68.266667a17.066667 17.066667 0 0 1-17.066667 17.066666z m426.666667-85.333333h-85.333333a17.066667 17.066667 0 0 1 0-34.133333h85.333333a17.066667 17.066667 0 1 1 0 34.133333zM341.333333 102.4h-85.333333a17.066667 17.066667 0 0 1 0-34.133333h85.333333a17.066667 17.066667 0 0 1 0 34.133333z"
          />
        </svg>
      </button>
    </ng-container>
    <ng-container *ngIf="isMultiNodeMoving()">
      <button
        mode="icon"
        class="ButtonMultiNodeMoving MultiNodeMoving"
        [class.isStreckengrafikEditing]="isStreckengrafikEditing() || isAnalytics()"
        [disabled]="isStreckengrafikEditing() || isAnalytics()"
        (click)="onMultiNodeMoving()"
        [title]="'app.view.editor-menu.multiple-selection-tool-enabled' | translate"
      >
        <svg
          viewBox="0 0 1024 1024"
          style="vertical-align: middle; pointer-events: none"
          height="31"
          width="31"
        >
          <path
            class="ButtonMultiNodeMoving"
            [class.disabled]="isStreckengrafikEditing() || isAnalytics()"
            d="M598.186667 955.733333h-0.443734a17.117867 17.117867 0 0 1-15.240533-10.325333L476.859733 699.733333H426.666667a17.066667 17.066667 0 1 1 0-34.133333h35.5328l-136.533334-317.525333a17.066667 17.066667 0 0 1 22.408534-22.408534l317.525333 136.533334V426.666667a17.066667 17.066667 0 1 1 34.133333 0v50.158933l245.640534 104.8064a17.083733 17.083733 0 0 1 0.9216 30.976l-149.486934 74.752 153.924267 153.924267a17.0496 17.0496 0 0 1 0 24.132266l-85.333333 85.333334a17.0496 17.0496 0 0 1-24.132267 0l-153.856-153.856-73.9328 149.3504a17.066667 17.066667 0 0 1-15.291733 9.489066zM682.666667 750.933333a17.066667 17.066667 0 0 1 12.066133 5.000534L853.333333 914.5344 914.5344 853.333333l-158.600533-158.600533a17.015467 17.015467 0 0 1 4.437333-27.323733l137.6768-68.829867-222.037333-94.737067-0.1024-0.034133-301.9776-129.877333 129.860266 301.994666 0.034134 0.068267 95.453866 222.020267 68.096-137.5744A17.066667 17.066667 0 0 1 682.666667 750.933333z m-341.333334-51.2h-85.333333a17.066667 17.066667 0 1 1 0-34.133333h85.333333a17.066667 17.066667 0 1 1 0 34.133333z m-170.666666 0H85.333333a17.066667 17.066667 0 0 1-17.066666-17.066666v-85.333334a17.066667 17.066667 0 1 1 34.133333 0v68.266667h68.266667a17.066667 17.066667 0 1 1 0 34.133333zM85.333333 529.066667a17.066667 17.066667 0 0 1-17.066666-17.066667v-85.333333a17.066667 17.066667 0 0 1 34.133333 0v85.333333a17.066667 17.066667 0 0 1-17.066667 17.066667z m597.333334-170.666667a17.066667 17.066667 0 0 1-17.066667-17.066667v-85.333333a17.066667 17.066667 0 1 1 34.133333 0v85.333333a17.066667 17.066667 0 0 1-17.066666 17.066667zM85.333333 358.4a17.066667 17.066667 0 0 1-17.066666-17.066667v-85.333333a17.066667 17.066667 0 0 1 34.133333 0v85.333333a17.066667 17.066667 0 0 1-17.066667 17.066667z m597.333334-170.666667a17.066667 17.066667 0 0 1-17.066667-17.066666V102.4h-68.266667a17.066667 17.066667 0 1 1 0-34.133333h85.333334a17.066667 17.066667 0 0 1 17.066666 17.066666v85.333334a17.066667 17.066667 0 0 1-17.066666 17.066666zM85.333333 187.733333a17.066667 17.066667 0 0 1-17.066666-17.066666V85.333333a17.066667 17.066667 0 0 1 17.066666-17.066666h85.333334a17.066667 17.066667 0 0 1 0 34.133333H102.4v68.266667a17.066667 17.066667 0 0 1-17.066667 17.066666z m426.666667-85.333333h-85.333333a17.066667 17.066667 0 0 1 0-34.133333h85.333333a17.066667 17.066667 0 1 1 0 34.133333zM341.333333 102.4h-85.333333a17.066667 17.066667 0 0 1 0-34.133333h85.333333a17.066667 17.066667 0 0 1 0 34.133333z"
          />
        </svg>
      </button>
    </ng-container>
  </div>

  <div class="NoteEditor" [class.isStreckengrafikEditing]="isStreckengrafikEditing()">
    <ng-container *ngIf="!isNoteEditing()">
      <button
        mode="icon"
        class="ButtonNoteEditor NetzgrafikEditing"
        [class.isStreckengrafikEditing]="isStreckengrafikEditing() || isAnalytics()"
        [class.readonly]="!getVariantIsWritable()"
        [disabled]="isStreckengrafikEditing() || isAnalytics() || !getVariantIsWritable()"
        (click)="onNoteEditor()"
        [title]="'app.view.editor-menu.note-editor-disabled' | translate"
      >
        <sbb-icon
          svgIcon="speech-bubble-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
    <ng-container *ngIf="isNoteEditing()">
      <button
        mode="icon"
        class="ButtonNoteEditor NoteEditing"
        [class.isStreckengrafikEditing]="isStreckengrafikEditing() || isAnalytics()"
        [disabled]="isStreckengrafikEditing() || isAnalytics()"
        (click)="onNoteEditor()"
        [title]="'app.view.editor-menu.note-editor-enabled' | translate"
      >
        <sbb-icon
          svgIcon="speech-bubble-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
  </div>

  <div
    class="AnalyticsShortestPathVisualisation"
    [class.isStreckengrafikEditing]="isStreckengrafikEditing()"
  >
    <ng-container *ngIf="!isAnalytics()">
      <button
        mode="icon"
        class="ButtonAnalytics"
        [class.isStreckengrafikEditing]="isStreckengrafikEditing()"
        [disabled]="isStreckengrafikEditing()"
        (click)="onAnalyticsShortestPathVisualisation()"
        [title]="'app.view.editor-menu.analytics-disabled' | translate"
      >
        <sbb-icon
          svgIcon="train-station-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
    <ng-container *ngIf="isAnalytics()">
      <button
        mode="icon"
        class="ButtonAnalytics ButtonAnalyticsActive"
        [class.isStreckengrafikEditing]="isStreckengrafikEditing()"
        [disabled]="isStreckengrafikEditing()"
        (click)="onAnalyticsShortestPathVisualisation()"
        [title]="'app.view.editor-menu.analytics-enabled' | translate"
      >
        <sbb-icon
          svgIcon="train-station-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
  </div>

  <div class="OriginDestination">
    <ng-container>
      <button
        mode="icon"
        class="ButtonStreckengrafikEditor NetzgrafikEditing ButtonOriginDestination"
        [class.ButtonOriginDestinationActive]="isOriginDestination()"
        (click)="onOriginDestination()"
        [title]="getOriginDestinationTitle()"
      >
        <sbb-icon
          _ngcontent-ng-c1568279807=""
          role="img"
          svgicon="chart-line-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
          class="sbb-icon notranslate"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            fill="none"
            viewBox="20 -8 72 94"
            fit=""
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
          >
            <g transform="rotate(30),scale(2.0),translate(20,-8)">
              <path
                d="M21.25 15.75c0 4.377-1.308 7.222-3.342 8.982-2.047 1.772-4.91 2.518-8.158 2.518v1c3.38 0 6.516-.774 8.813-2.762 2.309-2 3.687-5.155 3.687-9.738V9.482l3.857 3.849.707-.708L22.09 7.91l-.353-.353-.353.354-4.712 4.713.707.707 3.871-3.872z"
              />
            </g>
            <g transform="scale(2.5),translate(3,10)">
              <path
                width="26"
                height="20"
                d="M8 1C5.264 1 3 3.107 3 5.762v.021c.035.833.297 1.531.704 2.174l.007.01 3.886 5.811.416.621.416-.621 3.886-5.81.007-.01.006-.011c.393-.654.664-1.367.672-2.18v-.005C13 3.107 10.735 1 8 1M4.546 7.416C4.22 6.901 4.028 6.374 4 5.752 4.006 3.704 5.768 2 8 2c2.234 0 3.999 1.708 4 3.76-.006.58-.195 1.115-.523 1.661l-3.464 5.18zM6.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M8 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
              />
            </g>
            <g transform="rotate(-90),scale(2.0)translate(-22,23)">
              <path
                fill="#000"
                fill-rule="evenodd"
                d="M14.5 7a5.5 5.5 0 1 0 .002 11.002A5.5 5.5 0 0 0 14.5 7M3 13h5.019a6.5 6.5 0 1 0 0-1H3zm11.5 3a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                clip-rule="evenodd"
              />
            </g>
          </svg>
        </sbb-icon>
      </button>
    </ng-container>
  </div>

  <div class="NodeStreckengrafik">
    <ng-container *ngIf="!isStreckengrafikEditing()">
      <button
        mode="icon"
        class="ButtonStreckengrafikEditor NetzgrafikEditing"
        (click)="onStreckengrafik()"
        [class.isNotStreckengrafikAllowed]="isNotStreckengrafikAllowed()"
        [disabled]="isNotStreckengrafikAllowed()"
        [title]="'app.view.editor-menu.displayGraphicTimetable' | translate"
      >
        <sbb-icon
          svgIcon="chart-line-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
    <ng-container *ngIf="isStreckengrafikEditing()">
      <button
        mode="icon"
        class="ButtonStreckengrafikEditor StreckengrafikEditing"
        (click)="onStreckengrafik()"
        [title]="'app.view.editor-menu.closeGraphicTimetable' | translate"
      >
        <sbb-icon
          svgIcon="chart-line-medium"
          height="25px"
          width="25px"
          aria-hidden="false"
        ></sbb-icon>
      </button>
    </ng-container>
  </div>
</div>
